/**
 * This variable can assume this values when it will be builded on AppCenter:
 * - Development
 * - Production
 */
const INIT_ENVIRONMENT_PIPELINE = '#{DEPLOY_ENV}#';

export let deployEnvironment = INIT_ENVIRONMENT_PIPELINE;

export enum DeployEnvironmentEnum {
  Development = 'Development',
  Production = 'Production',
}
